import React, { useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { Viewer, Worker, ScrollMode, SpecialZoomLevel, ProgressBar } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
// Import styles
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import Alert from '@mui/material/Alert';

const PdfViewerComponent = ({ pdfUrl, handleCreatePDF }) => {
  useEffect(() => {
    setTimeout(() => handleCreatePDF?.(), 2500);
  }, []);
  const defaultLayoutPluginInstance = defaultLayoutPlugin();
  return (
    <Box
      sx={{
        height: '880px',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      {pdfUrl !== '' && pdfUrl !== 'ERROR' ? (
        <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
          <Viewer
            fileUrl={pdfUrl}
            plugins={[defaultLayoutPluginInstance]}
            ScrollMode={ScrollMode.Page}
            defaultScale={SpecialZoomLevel.ActualSize}
            // renderLoader={(percentage) => ()}
          />
        </Worker>
      ) : pdfUrl === 'ERROR' ? (
        <Alert severity="error">Unknown error occurred to process the pdf.</Alert>
      ) : null}
    </Box>
  );
};
export default PdfViewerComponent;
